var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1667 20C15.6896 20 20.1667 15.5228 20.1667 10C20.1667 4.47715 15.6896 0 10.1667 0C4.6439 0 0.166748 4.47715 0.166748 10C0.166748 15.5228 4.6439 20 10.1667 20Z",
    fill: "#4E9ED6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83202 13.1868L6.11393 10.485C6.03798 10.4091 6 10.3114 6 10.192C6 10.0727 6.03798 9.97504 6.11393 9.89908L6.71614 9.31315C6.7921 9.22634 6.88704 9.18294 7.00097 9.18294C7.11491 9.18294 7.21527 9.22634 7.30208 9.31315L9.12499 11.1361L13.0312 7.22982C13.118 7.14301 13.2184 7.09961 13.3323 7.09961C13.4463 7.09961 13.5412 7.14301 13.6172 7.22982L14.2194 7.81575C14.2953 7.89171 14.3333 7.98936 14.3333 8.10872C14.3333 8.22808 14.2953 8.32573 14.2194 8.40169L9.41796 13.1868C9.34201 13.2736 9.24435 13.317 9.12499 13.317C9.00564 13.317 8.90798 13.2736 8.83202 13.1868Z",
    fill: "#4E9ED6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.8970bae72c4668793163d78552a80428.svg";
export { ForwardRef as ReactComponent };